import { SET_GENERALSETTINGS_DATA } from './actionType';

const initailState = {
  settings: {},
};

const generalSettings = (state = initailState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_GENERALSETTINGS_DATA:
      const { settings } = payload;
      return {
        ...state,
        settings: {
          ...state.settings,
          ...settings,
        }
      };

    default:
      return state;
  }
};

export default generalSettings;



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/flow/reducer.js